'use strict';

module.exports = require('./src/DialogWrap');



// WEBPACK FOOTER //
// ./ext/dialog/index.js